import React from "react";
import "./Footer.css";
import { FaLinkedinIn, FaTwitter, FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import logo from "../../assets/logo.png";
import { siInstagram } from "simple-icons";
import linkedin from "../../assets/icons/linkdin_icon.png"
import twitter from "../../assets/icons/twitter_icon.png"
import insta from "../../assets/icons/insta_icon.png"

const NAV_COLUMNS = [
  {
    heading: "Navigate",
    links: [
      { label: "About", path: "/about" },
      { label: "Services", path: "/approach/ai-strategy" },
      { label: "Solutions", path: "/impact/ai-readiness" },
      { label: "Insights", path: "/thinking" },
      { label: "Opportunities", path: "/insights" },
      { label: "Contact", path: "/contact" },
    ],
  },


  {
    heading: "solutions",
    links: [
      { label: "AI Readiness Assessment", path: "/impact/ai-readiness" },
      { label: "Technology Assessment", path: "/impact/technology-assessment" },
      { label: "Operating Model Assessment", path: "/impact/operating-model" },
      { label: "Process Optimization Assessment", path: "/impact/process-optimization" },
      { label: "Digital Transformation Assessment", path: "/impact/dt-roadmap" },
    ],
  },

  {
    heading: "Contact",
    links: [
      { label: "ramesh@bairees.com", path: "mailto:ramesh@bairees.com" },
      { label: "+1 (571) 663-5980", path: "tel:+15716635980" },
      { label: " USA | Europe | Middle East | APAC | India", path: "/global-reach" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        {/* ── TOP SECTION ── */}
        <div className="footer-top">
          {/* Brand */}
          <div className="footer-brand">
            <img src={logo} alt="BaiRees Global Advisory" className="footer-logo" />
            <p className="footer-tagline">
              <span className=" footer-tagline-A">
                Navigating Complexity  <br />
                Enabling Clarity.  <br />
              </span>
              Building Intelligent Organizations™.
            </p>
            <div className="footer-socials">
              <a href="https://www.linkedin.com/company/bairees-global-advisory-pvt-ltd/" aria-label="LinkedIn" className="social-icon" target="_blank"
                rel="noopener noreferrer"><img src={linkedin} alt="linkedin" className="social-linkdin" /></a>
              <a href="https://x.com/BAIREESGLOBAL" aria-label="Twitter" className="social-icon" target="_blank"
                rel="noopener noreferrer"><img src={twitter} alt="twitter" /></a>
              <a href="https://www.instagram.com/baireesglobal?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                target="_blank" rel="noopener noreferrer" aria-label="Insta" className="social-icon">
                  <img src={insta} alt="insta" /></a>
            </div>
          </div>


          {/* Link columns */}
          <nav className="footer-nav">
            {NAV_COLUMNS.map((col) => (
              <div key={col.heading} className="footer-col">
                <h4 className="footer-col-heading">{col.heading}</h4>
                <ul className="footer-col-list">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      <a href={link.path} className="footer-link">{link.label}</a>
                    </li>
                  ))}
                  {col.extra && (
                    <li className="footer-cities">{col.extra}</li>
                  )}
                </ul>
              </div>
            ))}
          </nav>
        </div>

        {/* ── GOLD DIVIDER ── */}
        <div className="footer-divider" />

        {/* ── BOTTOM BAR ── */}
        <div className="footer-bottom">
          <p className="footer-copy">
            © 2026 BAIREES Global Advisory. All rights are reserved.
          </p>
          <div className="footer-policies">
            <a href="/privacy-policy" className="footer-policy-link">Privacy Policy</a>
            <span className="footer-policy-sep">|</span>
            <a href="/terms-of-use" className="footer-policy-link">Terms of Use</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
